import loginStyle from "../../../../../../assets/scss/common/modal/loginModal.module.scss";
import memberStyle from "../../../../../../assets/scss/sub/editMember.module.scss";
import React, {RefObject} from "react";
import {ValidateStatus} from "../hooks/useSignupValidator";
import {StyleRequestType} from "../../../../../../types/common";
import {useTranslation} from "react-i18next";
interface Props{
    name: string;
    setName: (_: string) => void;
    nameValidate: ValidateStatus;
    setNameValidate: (_: ValidateStatus) => void;
    styleRequestType: StyleRequestType;
    nameRef?: RefObject<HTMLInputElement>;
}
export function SignupNameField({name, setName, nameValidate, setNameValidate, styleRequestType, nameRef}:Props){
    const { t } = useTranslation("userInfo");
    const styles = styleRequestType === StyleRequestType.SIGN_UP ? loginStyle :  memberStyle;
    const handleSetName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNameValidate(ValidateStatus.NONE);
        setName(e.target.value.replace(/\s+/g, ''))
    };

    return (
        <div className={styles.selectWrapper}>
            <div className={styles.selectTitleWrapper}>
                <span className={styles.highLight}>{t('form.required')}</span>
                <span className={styles.titleText}>{t('form.name.label')}</span>
            </div>
            <div className={styles.selectTextFieldWrapper} >
                <input ref={nameRef}
                       maxLength={50}
                       type="name"
                       className={styles.selectText}
                       value={name}
                       onInvalid={(e) => e.preventDefault()}
                    // onChange={(e) => setName(e.target.value.toUpperCase())}
                       onChange={handleSetName}
                       placeholder={t('form.name.placeholder')}
                />
            </div>
            {nameValidate === ValidateStatus.UNFILLED &&
                (<span className={styles.validateText}>{t('edit.warning.name.unfilled')}</span>)
            }
            {nameValidate === ValidateStatus.LANGUAGE_MISMATCH &&
                (<span className={styles.validateText}>{t('edit.warning.name.mismatch')}</span>)
            }
        </div>
    )
}